import { getImage } from './get-image';
import { getImageDimension } from './get-image-dimension';

export interface CompressedImage {
    newDataURL: string;
    newFile: File;
}

export const compressImage = async (file: File): Promise<CompressedImage> => {
    const imageType = 'image/jpeg';
    const quality = 0.7;

    // eslint-disable-next-line compat/compat
    const dataUrl = URL.createObjectURL(file);
    const image = await getImage(dataUrl);
    const { naturalWidth, naturalHeight } = image;

    const maxWidthHeight = 1024;

    const isPortrait = naturalHeight >= naturalWidth;

    const aspectRatio = isPortrait
        ? naturalHeight / naturalWidth
        : naturalWidth / naturalHeight;

    const shouldResize = isPortrait
        ? naturalHeight > maxWidthHeight
        : naturalWidth > maxWidthHeight;

    const { width, height } = shouldResize
        ? getImageDimension(aspectRatio, maxWidthHeight, isPortrait)
        : { width: naturalWidth, height: naturalHeight };

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    ctx?.drawImage(image, 0, 0, width, height);

    const newDataURL = canvas.toDataURL(imageType, quality);

    const blob = await (await fetch(newDataURL)).blob();
    const newFile = new File([blob], file.name, {
        type: 'image/jpeg',
        lastModified: file.lastModified,
    });

    return { newFile, newDataURL };
};
